<template>
  <v-app-bar
    app
    flat
    :class="{ 'block-loading': blockLoading }"
    class="greyLight"
  >
    <v-menu
      v-if="$vuetify.breakpoint.mobile"
      left
      bottom
      offset-y
    >
      <template #activator="{ on, attrs }">
        <v-app-bar-nav-icon
          v-bind="attrs"
          v-on="on"
        >
        </v-app-bar-nav-icon>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, j) in mobileItems.filter((x) => !x.hide)"
          :key="j"
          :href="item.href"
          :to="item.to"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <div
      :style="{ 'max-width': '110px' }"
      style="max-height: 75px"
    >
      <img
        :src="logo"
        style="max-height: 80px; max-width: 100%"
        class="hover-pointer"
        @click="logoClick"
      />
    </div>
    <v-spacer />
    <template v-if="!$vuetify.breakpoint.mobile">
      <template v-for="(item, i) in items.filter((x) => !x.hide)">
        <v-menu
          v-if="item.children"
          :key="i"
          left
          bottom
          offset-y
        >
          <template #activator="{ on, attrs }">
            <v-btn
              text
              v-bind="attrs"
              v-on="on"
            >
              {{ item.title }}
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>

          <v-list>
            <template v-for="(child, j) in item.children">
              <v-divider
                v-if="child.topBorder"
                :key="j + 'divider'"
              />
              <v-list-item
                :key="j"
                :href="child.href"
              >
                <v-list-item-title>{{ child.title }}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
        <v-btn
          v-else
          :key="i + 'link'"
          text
          :href="item.href"
          :to="item.to"
        >
          {{ item.title }}
        </v-btn>
      </template>
    </template>
    <mcs-btn
      outlined
      color="black"
      class="mx-2"
      @click="goToLogin"
    >
      Log In
    </mcs-btn>
    <mcs-btn
      color="primary"
      @click="goToLogin"
    >
      Sign up
    </mcs-btn>
  </v-app-bar>
</template>

<script>
import { LINKS, ROUTES } from '@/utils/constants';
import { mapGetters } from 'vuex';

export default {
  name: 'UnauthorizedHeader',

  components: {},

  mixins: [],

  data() {
    return {
      profileLink: ROUTES.PROFILE.PATH,
      items: [
        {
          title: 'Templates',
          children: [
            { title: 'Brochures', href: this.getHref('templates/brochures') },
            { title: 'Flyers', href: this.getHref('templates/flyers') },
            { title: 'Postcards', href: this.getHref('templates/postcards') },
            { title: 'Door Hangers', href: this.getHref('templates/doorhangers') },
            { title: 'All Templates', href: this.getHref('templates'), topBorder: true }
          ]
        },
        {
          title: 'Print & Mail',
          children: [
            { title: 'Printing', href: this.getHref('print') },
            { title: 'Mail with SnailBlast', href: this.getHref('snailblast') }
          ],
          hide: !this.isMCS
        },
        {
          title: 'Print',
          href: LINKS.PRINT,
          hide: this.isMCS
        },
        {
          title: 'Learn',
          children: [
            { title: 'Make a Brochure', href: this.getHref('make/brochures') },
            { title: 'Make a Flyer', href: this.getHref('make/flyers') },
            { title: 'All Topics', href: this.getHref('learn'), topBorder: true }
          ],
          hide: !this.isMCS
        },
        { title: 'Pricing', href: this.getHref('pricing'), hide: !this.isMCS },
        { title: 'About', href: this.getHref('about-us'), hide: !this.isMCS }
      ],
      mobileItems: [
        { title: 'Templates', href: this.getHref('templates') },
        {
          title: 'Print',
          href: this.isMcs ? this.getHref('print') : '',
          to: this.isMCS ? '' : LINKS.PRINT
        },
        { title: 'Mail', href: this.getHref('snailblast'), hide: !this.isMCS },
        { title: 'Learn', href: this.getHref('learn'), hide: !this.isMCS },
        { title: 'Pricing', href: this.getHref('pricing'), hide: !this.isMCS },
        { title: 'About', href: this.getHref('about-us'), hide: !this.isMCS }
      ]
    };
  },

  computed: {
    blockLoading() {
      return this.$store.state.config.blockUILoading;
    },

    ...mapGetters({
      logo: 'config/logo',
      isMCS: 'user/isMCS',
      master_account: 'user/master_account'
    })
  },

  methods: {
    logoClick() {
      if (this.$portalMode() && this.master_account.homePageUrl) {
        window.location.href = this.master_account.homePageUrl;
      } else {
        window.location = this.$store.state.config.webUrl;
      }
    },
    getHref(append) {
      return `${process.env.VUE_APP_WEB_URL}${append}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-btn--text {
  font-size: 14px;
  font-weight: 400;
}
.v-btn--active::before {
  opacity: 0 !important;
}
</style>
